import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when SuspensePage fails to load a lazy chunk (network/CDN error). */
export class SuspensePageChunkLoadError extends ClientLayerError {
  static readonly className: string = 'SuspensePageChunkLoadError'

  constructor(error: unknown, route: string) {
    super(`Failed to load page chunk for route "${route}"`, { cause: error })
    this.setMarkupOptions({ scope: 'root', section: 'routing' })
    this.addFingerprintSegment('suspense-page-chunk-load')
  }
}

/** Logged when SuspensePage loads a module without a Component or default export. */
export class SuspensePageMissingComponentError extends ClientLayerError {
  static readonly className: string = 'SuspensePageMissingComponentError'

  constructor() {
    super('SuspensePage: Loaded module does not contain a Component or default export')
    this.setMarkupOptions({ scope: 'root', section: 'routing' })
    this.addFingerprintSegment('suspense-page-missing-component')
  }
}
